import '.bx{position:relative;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.g8{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.ce{align-items:flex-start;}.ssr-plugin'
import '.m{padding:2rem;}.ssr-plugin'
import '.d7{background:var(--shades-white);}.ssr-plugin'
import '.t{overflow:hidden;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.io{top:50%;}.ssr-plugin'
import '.ip{right:1rem;}.ssr-plugin'
import '.iq{transform:translateY(-50%);}.ssr-plugin'
import '.ir{width:120px;}.ssr-plugin'
import '.is{height:120px;}.ssr-plugin'
import '.it{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ht{z-index:1;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import '.iu{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bx z g8 a b g ce m d7 t"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="p io ip iq ir is it a c g"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bx ht a b ce an iu"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
